import React, { useEffect } from "react";
import { Registration, myCompany } from "../../assets/image";
import moment from "moment";
import { Calendar } from "iconsax-react";
import { Office, SmartHome } from "../../assets/svg/AllSvg";
import { useDispatch, useSelector } from "react-redux";
import { getOrganisationDetails } from "../../redux/organisation/slice";
import RippleLoader from "../../commons/RippleLoader";
import "../auth/Auth.css";
import "../dashboard/dashboard.css";

const MyCompany = () => {
  const dispatch = useDispatch();
  const companyId = sessionStorage.getItem("companyID");

  // Selector
  const { organizationDetails, loading } = useSelector((store) => ({
    organizationDetails:
      store?.organisationData?.getOrganisationDetailsStatus?.data?.data,
    loading: store?.organisationData?.loading,
  }));

  // Get APIs
  useEffect(() => {
    if (companyId) {
      dispatch(getOrganisationDetails(companyId));
    }
  }, [companyId, dispatch]);

  return (
    <>
      <div className="flex justify-between border-b border-b-secondary_lightGrey sm:pb-8 pb-4 mb-6">
        <div className="sm:flex flex-row items-center">
          <img src={myCompany} className="sm:w-auto w-28 sm:mb-0 mb-2" />
          <div>
            <p className="sm:text-3xl text-2xl font-ebGaramond font-normal sm:mb-0 mb-2">
              My Company Information
            </p>
            <h6 className="sm:text-sm text-xs font-poppins font-normal mb-1">
              Overview of your company key information and dates to take note
              off
            </h6>
          </div>
        </div>
      </div>
      {loading ? (
        <RippleLoader />
      ) : (
        <>
          <div className="lg:flex gap-2">
            <div className="box-content sm:w-80 rounded-lg drop-shadow-lg bg-white px-6 p-2 lg:mb-0 mb-4 ">
              <div>
                <p className="text-xl font-ebGaramond font-normal capitalize ml-8">
                  {organizationDetails?.name}
                </p>
                <div className="flex space-x-2">
                  <img
                    src={Registration}
                    alt="logo"
                    className="object-cover w-6 h-6"
                  />
                  <div>
                    <p className="text-sm font-ebGaramond font-normal text-gray-700">
                      Registration No.
                    </p>
                    <p className="text-sm font-ebGaramond font-normal text-black">
                      {organizationDetails?.uen ?? "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-1 ml-8">
                <p className="text-sm font-ebGaramond font-normal text-gray-700">
                  Incorporation Date
                </p>
                <p className="text-sm font-ebGaramond font-normal">
                  {moment(organizationDetails?.created_at).format("DD/MM/YYYY")}
                </p>
              </div>
            </div>
            {organizationDetails?.addresses?.map((item, index) => {
              return (
                index === 0 &&
                item?.address_type === "residental" && (
                  <div
                    className="box-content w-80 rounded-lg drop-shadow-lg bg-white px-6 p-2"
                    key={index}
                  >
                    <div className="p-1">
                      <div className="flex">
                        <Office />
                        <div>
                          <p className="text-xl font-ebGaramond font-normal ml-2">
                            Registered Office Address
                          </p>
                          <div className="ml-2">
                            <p className="text-sm font-ebGaramond font-normal text-gray-700 mt-1">
                              Address:
                            </p>
                            <p className="text-sm font-ebGaramond font-normal text-black capitalize">
                              {item?.address?.address_line_1 + " "}
                              {item?.address?.address_line_2 + " "}
                              {item?.address?.postal_code}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </div>

          <div className="bg-themeLight rounded-lg py-8 px-8 mt-6">
            <div className="flex text-theme space-x-2">
              <Calendar size="24" />
              <p className="font-ebGaramond sm:text-xl text-lg">
                Dates to note:
              </p>
            </div>
            <div className="mt-2 sm:flex justify-between">
              <div className="sm:w-40 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Financial Year End
                </p>
                <p className="text-sm font-poppins">
                  {organizationDetails?.financial_year_end_date &&
                    moment(organizationDetails?.financial_year_end_date).format(
                      "DD MMM YYYY"
                    )}
                </p>
              </div>
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Financial year end (FYE) is the completion of a one
                  yearaccounting period. It will determine when your corporate
                  filings and taxes are due.
                </p>
              </div>
            </div>
            <p className="border border-gray-400 mt-2"></p>

            <div className="mt-2 sm:flex justify-between">
              <div className="sm:w-40 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Annual General Meeting (AGM)
                </p>
                <p className="text-sm font-poppins">
                  {organizationDetails?.annual_general_meeting_date &&
                    moment(
                      organizationDetails?.annual_general_meeting_date
                    ).format("DD MMM YYYY")}
                </p>
              </div>
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  SGCorpHub will prepare and send you documents to sign!
                </p>
              </div>
            </div>
            <p className="border border-gray-400 mt-2"></p>

            <div className="mt-2 sm:flex justify-between">
              <div className="sm:w-40 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">Annual Return</p>
                <p className="text-sm font-poppins">
                  {organizationDetails?.annual_return_date &&
                    moment(organizationDetails?.annual_return_date).format(
                      "DD MMM YYYY"
                    )}
                </p>
              </div>
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Annual Return (an electronic form that contains important
                  information about the company) needs to be submitted to
                  Accounting & Corporate Regulatory Authority (ACRA), by
                  SGCorpHub, as soon as your AGM has been held.
                </p>
              </div>
            </div>
            <p className="border border-gray-400 mt-2"></p>

            <div className="mt-2 sm:flex justify-between">
              <div className="sm:w-40 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Tax Return (Form C/C-S)
                </p>
                <p className="text-sm font-poppins">
                  {organizationDetails?.tax_return_date &&
                    moment(organizationDetails?.tax_return_date).format(
                      "DD MMM YYYY"
                    )}
                </p>
              </div>
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Tax return (Form C/C-S) needs to be submitted by SGCorpHub to
                  Inland Revenue Authority of Singapore (IRAS) for the Year of
                  Assessment 2024 corresponding to your Financial Years ending
                  on 31 Dec 2023.
                </p>
              </div>
            </div>
            <p className="border border-gray-400 mt-2"></p>
          </div>

          <div className="bg-greenLight rounded-lg py-8 px-8 mt-6">
            <div className="flex space-x-2 text-theme">
              <SmartHome />
              <p className="font-ebGaramond sm:text-xl text-lg">
                Principal Activities
              </p>
            </div>
            <div className="mt-2 sm:flex justify-between">
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Primary Activities <br />
                  {organizationDetails?.primary_activity?.full_activity}
                </p>
              </div>
              <div className="sm:w-80 sm:space-y-0 space-y-1 sm:mb-0 mb-1">
                <p className="text-xs font-poppins font-light">
                  Secondary Activity <br />
                  {organizationDetails?.secondary_activity?.full_activity}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MyCompany;
